export default __webpack_public_path__ + "static/media/C270251.2060bca9.jpg";